import React from 'react';

export default function ButtonHome({ text, onClick = ()=>{} }) {
    // Definindo o objeto de estilo para manter o código limpo
    const buttonStyle = {
        backgroundColor: '#f3de1d',
        color: '#333',
        border: 'none',
        padding: '18px 35px',
        borderRadius: '12px',
        fontWeight: 'bold',
        fontSize: '1rem',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center', // Centraliza o texto
        gap: '10px',
        boxShadow: '0 10px 20px rgba(106, 27, 154, 0.3)',
        transition: '0.3s ease', // Adicionado para um efeito suave
        width: 'fit-content'
    };

    return (
        <button
            onClick={onClick}
            style={buttonStyle}
            onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
            onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
        >
            {text}
        </button>
    );
}